<!-- Desktop Layout -->
<header class="hidden lg:flex">
    <div class="bg-primary/20 header-background w-1/2 bg-cover bg-center">
        <div class="4xl:mr-32 4xl:pt-36 5xl:mr-40 5xl:pt-52 pt-5 lg:mr-6 xl:mr-20 xl:pt-10 2xl:mr-32 2xl:pt-27.5">
            <div class="flex justify-end opacity-50">
                <svg-icon src="assets/images/packbo-logo-white.svg" [svgStyle]="{ width: '86px', height: '67px' }" />
            </div>

            <h1 class="text-headline-large xl:text-display-large text-right text-white">
                {{ headerBlock().translations_refs | getTranslation: "title" }}
            </h1>
            <h1 class="text-headline-large xl:text-display-large text-secondary text-right">
                {{ headerBlock().translations_refs | getTranslation: "subtitle" }}
            </h1>

            <div
                class="bg-primary-95/60 border-primary mt-4 ml-auto flex w-fit items-center justify-end gap-4 rounded-lg border-2 px-3.5 py-2 focus-within:border-white 2xl:mt-8"
            >
                <div class="flex items-center gap-4">
                    <input
                        class="text-secondary w-16 opacity-60 outline-none lg:w-full"
                        placeholder="{{ 'home.search_placeholder' | transloco }}"
                        type="text"
                        [(ngModel)]="search"
                        (keyup.enter)="searchSuppliers()"
                    />
                    <span class="border-neutral-variant-40 h-8 border-r"></span>

                    <div class="flex items-center gap-2 opacity-60">
                        <svg-icon src="assets/icons/Compass-Arrow.svg" [svgStyle]="{ width: '16px', height: '16px' }" />
                        <input
                            class="text-secondary w-24 outline-none"
                            placeholder="{{ 'home.postal_code_placeholder' | transloco }}"
                            type="text"
                            mask="A0A 0A0|00000"
                            [dropSpecialCharacters]="false"
                            [validation]="true"
                            [(ngModel)]="postalCode"
                            (keyup.enter)="searchSuppliers()"
                        />
                    </div>

                    <el-select class="relative inline-block min-w-25" [value]="distance()">
                        <button
                            type="button"
                            class="flex w-full items-center justify-between gap-2 text-left opacity-60"
                        >
                            <svg-icon
                                src="assets/icons/Trip-Destination.svg"
                                [svgStyle]="{ width: '16px', height: '16px' }"
                            />
                            <el-selectedcontent class="text-secondary">
                                @if (distanceSearch()) {
                                    {{ distanceSearch() }}
                                } @else {
                                    {{ "home.distance_placeholder" | transloco }}
                                }
                            </el-selectedcontent>
                            <svg-icon
                                src="assets/icons/Arrow-Down-1.svg"
                                [svgStyle]="{ width: '16px', height: '16px' }"
                            />
                        </button>

                        <el-options
                            anchor="bottom start"
                            popover
                            class="max-h-60 w-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline outline-black/5 transition-discrete data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                        >
                            @for (distance of distances; track distance.value) {
                                <el-option
                                    [value]="distance.value"
                                    class="aria-selected:bg-primary hover:bg-primary/10 block cursor-pointer truncate px-3 py-2 select-none aria-selected:text-white"
                                    (click)="selectDistance(distance)"
                                >
                                    {{ distance.label }}
                                </el-option>
                            }
                        </el-options>
                    </el-select>
                </div>

                <button
                    class="bg-primary-30 hover:bg-primary-30/80 cursor-pointer rounded-full p-2 text-white"
                    type="button"
                    (click)="searchSuppliers()"
                    [attr.aria-label]="'home.search' | transloco"
                >
                    <svg-icon src="assets/icons/Search.svg" [svgStyle]="{ width: '16px', height: '16px' }" />
                </button>
            </div>
        </div>
    </div>

    <div class="bg-primary/20 w-1/2">
        <img
            class="h-auto w-full object-cover"
            [src]="headerBlock().image | getDirectusImage"
            alt="Header Block Image"
            priority="true"
            fetchpriority="high"
        />
    </div>
</header>

<!-- Mobile Layout -->
<header class="mobile-header-background lg:hidden">
    <div class="px-4 py-8">
        <div class="flex items-center justify-between px-4 pt-11 pb-6">
            <div class="flex flex-col gap-2">
                <h1 class="text-headline-large leading-none text-white">
                    {{ headerBlock().translations_refs | getTranslation: "title" }}
                </h1>
                <h1 class="text-headline-large leading-none">
                    {{ headerBlock().translations_refs | getTranslation: "subtitle" }}
                </h1>
            </div>

            <div class="flex justify-end opacity-50">
                <svg-icon src="assets/images/packbo-logo-white.svg" [svgStyle]="{ width: '86px', height: '67px' }" />
            </div>
        </div>

        <div class="bg-primary-95/60 border-primary rounded-lg border-2 p-4 focus-within:border-white">
            <div class="flex flex-col gap-4">
                <div class="flex items-center rounded-lg">
                    <input
                        class="text-body-small text-secondary flex-1 opacity-60 outline-none"
                        placeholder="{{ 'home.search_placeholder' | transloco }}"
                        type="text"
                        [(ngModel)]="search"
                        (keyup.enter)="searchSuppliers()"
                    />
                    <button
                        class="bg-primary-30 hover:bg-primary-30/80 cursor-pointer rounded-full p-2 text-white"
                        type="button"
                        (click)="searchSuppliers()"
                        [attr.aria-label]="'home.search' | transloco"
                    >
                        <svg-icon
                            src="assets/icons/Search.svg"
                            [svgStyle]="{ width: '16px', height: '16px' }"
                            aria-hidden="true"
                        />
                    </button>
                </div>

                <div class="flex justify-center">
                    <span class="bg-neutral-variant-40/20 h-px w-full"></span>
                </div>

                <div class="flex gap-2">
                    <div class="flex w-1/2 items-center rounded-lg opacity-60">
                        <svg-icon
                            src="assets/icons/Compass-Arrow.svg"
                            [svgStyle]="{ width: '16px', height: '16px' }"
                            class="mr-2"
                        />
                        <input
                            class="text-body-small text-secondary flex-1 outline-none"
                            placeholder="{{ 'home.postal_code_placeholder' | transloco }}"
                            type="text"
                            mask="A0A 0A0|00000"
                            [dropSpecialCharacters]="false"
                            [validation]="true"
                            [(ngModel)]="postalCode"
                            (keyup.enter)="searchSuppliers()"
                        />
                    </div>

                    <div class="w-1/2">
                        <el-select class="relative w-full" [value]="distance()">
                            <button type="button" class="flex w-full cursor-default items-center justify-between gap-2">
                                <div class="flex items-center gap-2 opacity-60">
                                    <svg-icon
                                        src="assets/icons/Trip-Destination.svg"
                                        [svgStyle]="{ width: '16px', height: '16px' }"
                                    />
                                    <el-selectedcontent class="text-secondary">
                                        @if (distanceSearch()) {
                                            {{ distanceSearch() }}
                                        } @else {
                                            {{ "home.distance_placeholder" | transloco }}
                                        }
                                    </el-selectedcontent>
                                </div>
                                <svg-icon
                                    src="assets/icons/Arrow-Down-1.svg"
                                    [svgStyle]="{ width: '16px', height: '16px' }"
                                />
                            </button>

                            <el-options
                                anchor="bottom start"
                                popover
                                class="max-h-60 w-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline transition-discrete data-leave:transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm"
                            >
                                @for (distance of distances; track distance.value) {
                                    <el-option
                                        [value]="distance.value"
                                        class="aria-selected:bg-primary block cursor-pointer truncate px-3 py-2 select-none hover:bg-gray-50 aria-selected:text-white"
                                        (click)="selectDistance(distance)"
                                    >
                                        {{ distance.label }}
                                    </el-option>
                                }
                            </el-options>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex">
        <span class="left-triangle min-w-1/2"></span>
        <span class="right-triangle min-w-1/2"></span>
    </div>
</header>
